// src/pages/admin/SecurityPrivacyPage.js
import React from "react";

const SecurityPrivacyPage = () => {
  return (
    <main className="flex-1 p-8">
      <h1 className="text-3xl font-bold text-gray-800 mb-4">Security & Privacy</h1>
      <p className="text-gray-600 mb-6">
        Manage security policies, authentication, and site protection measures.
      </p>

      <div className="bg-white p-6 rounded-xl shadow">
        <ul className="space-y-2 text-gray-700 text-sm list-disc list-inside">
          <li>Enable HTTPS & SSL/TLS</li>
          <li>Bot & Spam Protection</li>
          <li>Content Security Policy</li>
          <li>Firewall & API Security</li>
          <li>Malware Monitoring</li>
          <li>Strict Transport Security (HSTS)</li>
        </ul>
      </div>
    </main>
  );
};

export default SecurityPrivacyPage;
